module.exports = __webpack_public_path__ + "static/img/recentPage.9423c548.jpg";